<template>
  <mt-popup
      v-model="isShowPay"
      class="pay__way"
      mg-stat-mod="c_hwpaypop"
      position="bottom"
  >
    <section>
      确认付款
      <span
          :mg-stat-custom="'cont=关闭&label=pop&direct=cntp'"
          :mg-stat-lob="`order_id=${orderId}${
          crowdId ? '&crowd_id=' + crowdId : ''
        }`"
          mg-stat-click
          @click="isShowPay = false"
      >X</span
      >
    </section>
    <section>
      <div class="pay__way-money">{{ showPrice }}</div>
      <div class="pay__way-title">选择付款方式</div>
      <div class="pay__way-platform">
        <mt-spinner v-if="isLoading" type="snake"></mt-spinner>
        <div
            v-if="showAlipay && !isLoading"
            :mg-stat-custom="'cont=支付宝支付&label=btn&direct=cntp'"
            :mg-stat-lob="`order_id=${orderId}${
            crowdId ? '&crowd_id=' + crowdId : ''
          }`"
            mg-stat-click
            @click="submitPay('alipay')"
        >
          <p><img :src="alipayPng"/></p>
          <p>支付宝支付</p>
        </div>
        <div
            v-if="showWechart && !isLoading"
            :mg-stat-custom="'cont=微信支付&label=btn&direct=cntp'"
            :mg-stat-lob="`order_id=${orderId}${
            crowdId ? '&crowd_id=' + crowdId : ''
          }`"
            mg-stat-click
            @click="submitPay('wechart')"
        >
          <p><img :src="weChartPng"/></p>
          <p>微信支付</p>
        </div>
        <div
            v-if="showWallet && !isLoading&&!isPointsMall"
            :mg-stat-custom="'cont=芒果钱包支付&label=btn&direct=cntp'"
            :mg-stat-lob="`order_id=${orderId}${
            crowdId ? '&crowd_id=' + crowdId : ''
          }`"
            mg-stat-click
            @click="submitPay('wallet')"
        >
          <p><img :src="mgtvPng"/></p>
          <p>芒果钱包支付</p>
        </div>
      </div>
    </section>
  </mt-popup>
</template>
<script>
import _ from 'lodash';
import weChartPng from 'assets/img/wechart.png';
import mgtvPng from 'assets/img/mgtv.png';
import alipayPng from 'assets/img/alipay.png';
import * as payApi from 'apis/pay';
import * as userApi from 'apis/user';
import { callPay, getPayCodeNum } from 'utils/pay';
import { getQueryParams } from 'utils';
import { mapMutations } from 'vuex';
import Env from 'utils/env';
import { beforeRouteChange } from 'utils/uploadData';
import MgStat from 'MgStat';

export default {
  props: [
    'isShow',
    'payCode',
    'needGo',
    'orderId',
    'price',
    'originPage',
    'oldOrderId',
    'couponId',
    'goodsids',
    'goodsidsAndNum',
    'specids',
    'type',
    'crowdId',
    'orderType',
    'storeId',
  ],
  data() {
    return {
      weChartPng,
      mgtvPng,
      alipayPng,
      isShowPay: false,
      nowPayWay: null,
      isLoading: false,
      wx_openid: null,
    };
  },
  watch: {
    isShow: {
      handler(val) {
        this.isShowPay = _.cloneDeep(val);
        if (this.isShowPay) {
          const msgdata = { order_id: this.orderId };
          if (this.crowdId) {
            msgdata.crowd_id = this.crowdId;
          }
          MgStat.send('cv', msgdata, {
            mod: 'c_hwpaypop',
          });
        }
      },
      immediate: true,
    },
    isShowPay: {
      handler(val) {
        this.$emit('changeVisible', val);
        if (!val && this.needGo) {
          this.clearNoteData();
          beforeRouteChange(
            { path: 'order/all', query: { type: 'WAITPAY' } },
            this.originPage,
          );
        }
      },
    },
    payCode: {
      handler(val) {
        this.nowPayWay = _.cloneDeep(val);
      },
      immediate: true,
    },
  },
  computed: {
    showPrice() {
      const { price } = this;
      if (price && String(price).indexOf('¥') === -1) {
        return `¥${price}`;
      }
      return price;
    },
    /* 如果下单后用户点击了某种支付方式  如果支付失败 用户再次去支付 只能选择之前的支付方式 */
    showAlipay() {
      const { nowPayWay } = this;
      return (nowPayWay === 'alipay' || !nowPayWay) && !Env.isWeixin; // 微信内不支持支付宝
    },
    showWechart() {
      const { nowPayWay } = this;
      return Env.isWeixin || nowPayWay === 'wechart' || !nowPayWay;
    },
    showWallet() {
      const { nowPayWay } = this;
      return (nowPayWay === 'wallet' || !nowPayWay) && Env.isMgtvApp;
    },
    isPointsMall() {
      return this.storeId != null && this.storeId == 97;
    },
  },
  created() {
    if (Env.isWeixin) {
      // 如果用户首次在微信打开芒果好物 支付的时候 需跳转微信的xx页面获取code 获取完跳转回来  再直接吊起支付
      const { href } = window.location;
      if (href.indexOf('html?code') !== -1) {
        const [host] = href.split('index.html');
        const [, hash] = href.split('#');
        const hasParam = hash.indexOf('?') !== -1;
        const [, code] = href.match(/[?](\S*)[#]/);
        const url = `${host}index.html#${hash}${hasParam ? '&' : '?'}${code}`;
        window.location.replace(url);
        return;
      }
      const { code } = getQueryParams(href);
      if (code) {
        // 拿到code  直接调起支付
        this.weixinPay(code);
      }
    }
  },
  methods: {
    ...mapMutations('pay', ['clearNoteData']),
    getPayCodeNum,
    async confirmPay({
      orderId,
      way: payWay,
      payCodeNum,
      returnUrl,
      price,
      openId,
      orderType,
    }) {
      try {
        const { url: payUrl, business_order_id: businessOrderId } = await payApi.comfirmPay({
          orderType,
          orderId,
          payCode: payWay,
          payCodeNum,
          channelType: Env.isWeixin ? 'WXJS' : '',
          returnUrl,
          openId: Env.isWeixin ? openId : '',
        });
        if (!Env.isWeixin) {
          this.clearNoteData();
        }
        const callback = (status) => {
          this.clearNoteData();
          if (Env.isWeixin) {
            const oldcss = document.getElementById('app').style.cssText;
            document.getElementById('app').style.cssText = `${oldcss}opacity:1`;
          }
          let pat_status = 1;
          if (status === 'success') {
            pat_status = 0;
            if (orderType && orderType === 1) {
              this.$router.push({
                path: '/member/success',
                query: {
                  orderId: this.oldOrderId || orderId,
                  newOrderId: this.orderId,
                  status,
                },
              });
            } else {
              this.$router.push({
                path: '/pay/success',
                query: {
                  orderId: this.oldOrderId || orderId,
                  newOrderId: this.orderId,
                  status,
                },
              });
            }
          } else if (this.$route.name !== 'order_all') {
            if (orderType === 1) {
              // this.isShowPay = false;
            } else {
              this.$router.push({
                path: '/order/all',
                query: { type: 'WAITPAY' },
              });
            }
          }
          if (this.type === 'order_pay') {
            const msgdata = {
              order_id: this.oldOrderId || orderId,
              status: pat_status,
            };

            if (this.crowdId) {
              msgdata.crowd_id = this.crowdId;
            }
            MgStat.send('click', msgdata, {
              mod: 'haowu_order_pay',
              cont: '支付结果',
              direct: 'cntp',
              label: 'text',
              cntp: 'haowu_pay_success',
            });
          }
        };
        const pay = () => {
          callPay({
            isNewPayVersion: this.isPointsMall,
            orderId,
            price,
            payWay,
            payUrl,
            returnUrl,
            businessOrderId,
            payCodeNum,
            callback,
          });
        };
        this.$emit('clickPay', pay);
      } catch (error) {
        this.$toast(`唤起支付失败:${error.message}`);
        // this.$router.push({ path: '/order/all', query: { type: 'WAITPAY' } });
      }
    },
    async submitPay(way) {
      this.nowPayWay = way;
      const {
        orderId, price, oldOrderId, orderType = 0,
      } = this;
      const payCodeNum = getPayCodeNum(way, this.isPointsMall);
      this.isLoading = true;
      const [host] = window.location.href.split('index.html');
      // 付尾款的时候生成新订单 用新orderId去支付  用旧的查订单信息 （因为新的订单不在前端显示，所以成功回调页面查询定金订单的信息）
      let returnUrl = `${host}index.html#/pay/success/?orderId=${
        oldOrderId || orderId
      }&newOrderId=${orderId}`;
      if (orderType && orderType === 1) {
        returnUrl = `${host}index.html#/member/success/?orderId=${
          oldOrderId || orderId
        }&newOrderId=${orderId}`;
      }
      const payParams = {
        orderId,
        way,
        payCodeNum,
        returnUrl,
        price,
        orderType,
      };
      try {
        if (Env.isWeixin && way === 'wechart') {
          const { wxOpenid } = await userApi.getUserInfo();
          if (!wxOpenid) {
            // 用户在微信内第一次注册时 注册成功后 要跳到微信提供的url 它会再跳回来
            sessionStorage.setItem('weixinParams', JSON.stringify(payParams));
            const weixin_url = await userApi.getWeixinCode({
              redirectUrl: encodeURIComponent(window.location.href),
            });
            window.location.href = weixin_url;
            return;
          }
          payParams.openId = wxOpenid;
        }
        await this.confirmPay(payParams);
      } catch (error) {
        this.$toast(`${error.message}`);
      }
      this.isLoading = false;
    },
    async weixinPay(code) {
      try {
        const wx_openid = await userApi.getWeixinOpenId({ code });
        const payParams = sessionStorage.getItem('weixinParams');
        if (payParams && wx_openid) {
          const obj = JSON.parse(payParams);
          sessionStorage.removeItem('weixinParams');
          obj.openId = wx_openid;
          const oldcss = document.getElementById('app').style.cssText;
          document.getElementById('app').style.cssText = `${oldcss}opacity:0`; // 微信内支付  如果用户第一次登陆 调起支付的时候 会从A页面跳往微信的地址注册之后再跳回A页面  此时A页面应该为空白（优化体验，主要是优化结算页信息显示不全的问题）
          await this.confirmPay(obj);
        }
      } catch (error) {
        this.$toast(`${error.message}`);
      }
    },
  },
};
</script>
<style lang="scss">
.pay {
  &__way {
    width: 100%;

    section:first-child {
      height: 86px;
      line-height: 86px;
      font-size: 30px;
      font-weight: 600;
      text-align: center;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
      position: relative;

      span {
        line-height: 1;
        position: absolute;
        right: 30px;
        top: 25px;
        font-size: 33px;
        color: #b4b4b4;
      }
    }

    section:last-child {
      padding: 45px 32px 60px 32px;
    }

    &-tip {
      padding: 20px;
      font-size: 26px;
      text-align: center;
    }

    &-money {
      font-size: 45px;
      color: #ff4c00;
      text-align: center;
    }

    &-title {
      font-size: 28px;
      color: #4a4a4a;
      margin: 32px 0 74px 0;
    }

    &-platform {
      display: flex;
      justify-content: space-around;
      font-size: 26px;

      div {
        text-align: center;

        img {
          max-width: 90px;
          height: 90px;
        }
      }
    }
  }
}
</style>
